<style lang='less' scoped>
@import '../base.less';
</style>
<template>
  <div>
    <!-- SEARCH -->
    <Row>
      <Col span="24">
        <Card class="margin-bottom-10">
          <Form inline>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.user_id' :placeholder="$t('用户ID') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.mobile' :placeholder="$t('用户手机') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.username' :placeholder="$t('用户名') "></Input>
            </FormItem>
            <FormItem style="margin-bottom: 0">
              <Col span="12">
                <DatePicker type="datetimerange" @on-change="timeChange" :options="timeOptions"
                            :value='searchConf.searchTime' placeholder="创建时间" format="yyyy-MM-dd"
                            style="width: 200px"></DatePicker>
              </Col>
            </FormItem>

            <FormItem class="margin-bottom-0">
              <Button type="primary" @click="search">{{ $t("find_button") }}</Button>
            </FormItem>
          </Form>
        </Card>
      </Col>
    </Row>        <!--    -->
    <Row>
      <Col span='24'>
        <Card>
          <!-- ADDBUTTON -->
          <!--          <div class='margin-bottom-15'>-->
          <!--            <Button type='primary'  @click='preAdd' icon='md-add'>{{-->
          <!--                $t('清理广告记录')-->
          <!--              }}-->
          <!--            </Button>-->
          <!--          </div>-->
          <!-- DATA -->
          <div>
            <Table @on-sort-change="sortChange" :loading='listLoading' :columns='columnsList' :data='tableData'
                   border></Table>
          </div>
          <!-- PAGE -->
          <div class='margin-top-15' style='text-align: center'>
            <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                  @on-change='changePage' @on-page-size-change='changeSize'
                  :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
          </div>
        </Card>
      </Col>
    </Row>


  </div>
</template>
<script>
import {
  customPost
} from '@/api/Lhc/Lhc'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'

export default {
  name: 'interface_list',
  data() {
    return {
      timeOptions: {
        shortcuts: [{
          text: '今天',
          value() {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value() {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value() {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [{
        title: this.$t('ID'),
        key: 'id',
        minWidth: 50,
        align: 'center'
      }, {
        title: this.$t('用户手机'),
        key: 'mobile',
        minWidth: 50,
        align: 'center'
      }, {
        title: this.$t('用户名'),
        key: 'username',
        minWidth: 50,
        align: 'center'
      },  {
        title: '头像',
        sortable: true,
        align: 'center',
        width: 50,
        render: (h, params) => {
          let vm = this
          return h('img', {
            attrs: {
              style: 'height:50px',
              src:params.row.avator
            }
          })
        }
      }, {
        title: this.$t('最后登录IP'),
        key: 'last_login_ip',
        minWidth: 60,
        align: 'center'
      }, {
        title: this.$t('最后登录时间'),
        key: 'last_login_time',
        minWidth: 60,
        align: 'center'
      },{
        title: this.$t('是否封号'),
        align: 'center',
        minWidth: 110,
        key: 'is_lock',
        render: (h, params) => {
          return h('div', [
            h('span', {
              style: {
                color: params.row.is_lock ? '#ed4014' : '#19be6b',
                borderRadius: '11px',
                border: params.row.is_lock ? '1px solid #ed4014' : '1px solid #19be6b',
                display: '',
                height: '25px',
                width: '70%',
                lineHeight: '25px',
                padding: '3px'
              },
            }, (params.row.is_lock ? this.$t('是') : this.$t('否'))),
            params.row.is_lock
          ])
        }
      },  {
        title: this.$t('操作'),
        align: 'center',
        minWidth: 150,
        render: (h, params) => {
          let vm = this
          return h('div', [h('Poptip', {
            props: {
              confirm: true,
              title: params.row.is_lock === 0? this.$t('您确定要封号?'): this.$t('您确定要解封?'),
              transfer: true
            },
            on: {
              'on-ok': () => {
                customPost('tuku/UserManage', {op:'change',id:params.row.id,changeType:0}).then(response => {
                  this.$Message.success(response.data.msg)
                  this.getList();
                })
              }
            }
          }, [
            h('Button', {
              style: {
                margin: '0 5px'
              },
              props: {
                type:params.row.is_lock===0?this.$t('error'):this.$t('warning'),
                placement: 'top',
                loading: params.isDeleting
              }
            }, params.row.is_lock==0?this.$t('封号'):this.$t('解封'))
          ])])
        }
      }, {
        title: this.$t('创建时间'),
        key: 'created_at',
        minWidth: 50,
        align: 'center'
      }, {
        title: this.$t('等级'),
        key: 'level',
        minWidth: 50,
        align: 'center'
      }, {
        title: this.$t('备注'),
        key: 'level',
        minWidth: 50,
        align: 'center'
      }],
      tableData: [],//用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 50,
        listCount: 0
      },
      searchConf: {searchTime: [],}, // 搜索字段
      extraParams: [],
      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      windowAdd: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowAddItem: { //弹窗数据绑定
        id: 0
      },
      windowAddValidate: {//窗口校验规则
      },                            //----------------

      //弹窗--------------
      windowPL: { //弹窗
        show: false,
        loading: false,
        index: 0,
        isOut:false
      },

      windowPLItem: { //弹窗数据绑定
        id: 0
      },
      windowPLValidate: {//窗口校验规则
      },                            //----------------
    }
  },
  created() {
    let vm = this
    vm.getList()
  },
  mounted() {

  },
  methods: {
    preAdd() {
      let vm = this
      vm.windowAddItem.id=0;
      vm.windowAddItem.author='';
      vm.windowAddItem.signature='';
      vm.windowAdd.show = true
    },
    changePage(page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize(size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search() {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList() {
      let vm = this
      vm.listLoading = true
      vm.searchConf.page= vm.tableShow.currentPage
      vm.searchConf.size= vm.tableShow.pageSize
      customPost('tuku/UserManage',vm.searchConf).then(response => {
        vm.tableData = response.data.data.list
        vm.tableShow.listCount = response.data.data.count
        vm.listLoading = false
      })
    },

    timeChange(datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    sortChange: function ({column, key, order}) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    }
  }
}
</script>
